import { h } from "preact";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	title: {
		flexGrow: 1,
	},
}));

export default function UserIcon() {
	return (
		<svg width="57px" height="56px" viewBox="0 0 57 56" version="1.1" xmlns="http://www.w3.org/2000/svg">
			<title>Se connecter</title>
			<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
				<g id="UserIcon" transform="translate(0.989194, -0.000004)">
					<path
						d="M27.6108057,18.1799918 C29.9456604,18.1855234 31.8344781,20.0817961 31.8308058,22.4166546 C31.8271227,24.751513 29.9323408,26.6418261 27.5974802,26.6399919 C25.2626196,26.6381549 23.3708057,24.744865 23.3708057,22.4100036 C23.3708057,21.2864031 23.8178344,20.2089678 24.6132774,19.4154009 C25.4087204,18.6218339 26.4872083,18.1773474 27.6108057,18.1799918 M27.6108057,17.1800036 C25.4954681,17.1800036 23.5884203,18.4542522 22.7789157,20.4085693 C21.9694111,22.3628864 22.4168677,24.6124026 23.9126372,26.1081721 C25.4084067,27.6039416 27.6579229,28.0513982 29.61224,27.2418936 C31.5665571,26.432389 32.8408057,24.5253412 32.8408057,22.4100036 C32.8353029,19.5238368 30.4969725,17.1855064 27.6108057,17.1800036 L27.6108057,17.1800036 Z"
						id="Shape"
						fill="#FF3426"
						fill-rule="nonzero"
					></path>
					<path
						d="M16.2308057,38.0000036 C17.3635385,33.0783374 21.5311933,29.4421689 26.5609921,28.9871894 C31.5907908,28.5322099 36.3432894,31.3614898 38.3408057,36.0000036 C38.6232939,36.6453718 38.8475197,37.3147027 39.0108057,38.0000036"
						id="Path"
						stroke="#FF3426"
						stroke-linecap="round"
						stroke-linejoin="round"
					></path>
					<path
						d="M27.6108057,1.00000365 C42.30158,1.00000365 54.2108057,12.9092293 54.2108057,27.6000036 C54.2108057,42.290778 42.30158,54.2000036 27.6108057,54.2000036 C12.9200313,54.2000036 1.01080565,42.290778 1.01080565,27.6000036 C1.02183548,12.9138004 12.9246024,1.01103347 27.6108057,1.00000365 M27.6108057,1.8228857e-06 C16.4467386,-0.00404130469 6.37970838,6.71791763 2.1046018,17.03101 C-2.17050479,27.3441023 0.188365075,39.2169942 8.08112264,47.1126125 C15.9738802,55.0082308 27.8459165,57.3714031 38.1605574,53.1000341 C48.4751983,48.8286651 55.2008057,38.7640715 55.2008057,27.6000036 C55.2008057,12.3608489 42.8499594,0.00552508028 27.6108057,1.8228857e-06 Z"
						id="Shape"
						fill="#FF3426"
						fill-rule="nonzero"
					></path>
				</g>
			</g>
		</svg>
	);
}
